<script>
export default {
  name: "CheckIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  }
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" role="img" aria-label="Ícone de check">
    <title>Ícone de check</title>
    <path
      d="M14.624 6.26918C14.9475 7.85676 14.717 9.50727 13.9708 10.9454C13.2247 12.3836 12.0081 13.5225 10.5238 14.1723C9.03962 14.822 7.37751 14.9433 5.8147 14.5159C4.25188 14.0884 2.88283 13.1382 1.93585 11.8235C0.988864 10.5089 0.521195 8.9093 0.610829 7.29158C0.700463 5.67385 1.34198 4.13574 2.4284 2.93376C3.51482 1.73177 4.98048 0.938566 6.58095 0.686416C8.18142 0.434265 9.81995 0.738412 11.2233 1.54814M5.55667 6.97752L7.68167 9.10252L14.765 2.01919"
      :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>